module.exports = __webpack_public_path__ + "fonts/fontello.fa6b17e.eot";